import React from 'react';
import { Badge, Box, Divider, Heading } from '@hover/blueprint';

interface Props {
  id: number;
  image: React.ReactNode;
  activeSlide: number;
  totalSlidesLength: number;
  body: string;
}

const DesktopSlide: React.FC<Props> = ({
  id,
  image,
  totalSlidesLength,
  activeSlide,
  body,
  ...rest
}) => (
  <Box
    d="flex !important"
    alignItems="center"
    justifyContent="space-between"
    className="svg-back"
    role="group"
    aria-labelledby="number-of-the-slide"
    {...rest}
  >
    <Box
      className={id !== 5 ? 'mobile-image-container' : 'svg-image-container'}
      ml={id !== 5 ? '3px' : '1px'}
      maxW="378px"
      maxH="530px"
    >
      {image}
    </Box>
    <Box ml={1000} flex={1} justifyContent="center" flexDir="column">
      <Badge
        colorScheme="brandNavy"
        variant="brand"
        d="flex"
        alignItems="center"
        justifyContent="center"
        w={400}
        h={400}
        borderRadius="50%"
      >
        <Heading
          id={id === activeSlide ? 'number-of-the-slide' : ''}
          size={500}
          marginBottom={0}
          role="heading"
          aria-label={`Slide ${id + 1} of ${totalSlidesLength}`}
          as="p"
        >
          {id + 1}
        </Heading>
      </Badge>
      <Divider
        aria-hidden
        borderWidth="2px"
        my={600}
        w={400}
        borderColor="brandNavy.300"
        className="slider-divider"
      />
      <Heading maxW="380px" isLight size={500} as="p">
        {body}
      </Heading>
    </Box>
  </Box>
);

export default DesktopSlide;
